module.exports = __webpack_public_path__ + "109d6baecb5fca3c09a4eeb45e660134.png";